import { JobStats } from '../../../../interfaces/job';

export const JOB_STATS_NAMES: { [key in keyof JobStats]: string } = {
  startedAt: 'Started At',
  duration: 'Duration',
  latency: 'Max Latency',
  objectsSuccess: 'Objects Successful',
  objectsQueued: 'Objects Queued',
  objectsFailed: 'Objects Failed',
  eventsIngested: 'Events Ingested',
  eventsLoaded: 'Events Loaded',
  eventsFailed: 'Events Failed',
  billableEvents: 'Billable Events',
  nonBillableEvents: 'Non-billable Events'
};
